import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const SpecializationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <rect width="25" height="25" fill="url(#pattern0_2346_2227)" />
        <defs>
          <pattern id="pattern0_2346_2227" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlinkHref="#image0_2346_2227" transform="scale(0.01)" />
          </pattern>
          <image
            id="image0_2346_2227"
            width="100"
            height="100"
            preserveAspectRatio="none"
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAvu95BAAADxUlEQVR4Ae2cWY7UMBRFKcQGEGtiAYh5br5YBZtgPbAh4Ks/md9ttSXLclKVNzi2c59kZSi/wffEcVWluk93aOcU+Heug+frdz2DMZZdAQKxa+gagUBc5bQHu2cPcbgIp8gRc4ZEqquITSAK0SJdCCRSXUVsAlGIFulCIJHqKmITiEK0SBcCiVRXEZtAFKJFuhBIpLqK2ASiEC3ShUAi1VXEJhCFaJEuBBKpriI2gShEi3QhkEh1FbEJRCFapAuBRKqriE0gCtEiXQgkUl1F7BmeqTf93ZRC400unCGb5IrvTCDxGm/KQCCb5IrvPMMaUqoU+rupMpn3MWeIt6LGeARiFNDbnUC8FTXGIxCjgN7uBOKtqDEegRgF9HYnEG9FjfEIxCigtzuBeCtqjEcgRgG93QnEW1FjPAIxCujtTiDeihrjEYhRQG93AvFW1BiPQIwCersTiLeixngEohPwgbh9lfZXGn714tEkzBxWitFiVJ8kSZnXenxTd4tn6ih0Nhv6zmK9crb6t4B/X5J8kfZT2tb6lvq3qPsmx1IBUeebDWxjosfSfw3gxnD67lHCL8XVVxrn+URCr8HAWJpZKVyzxJ0keip1/JKW61AeE0gjWLWZ8VtyvywAEUgDIGswkD6fMQQSDAQwytsSZsarLC+BZGJE7l4CA/kJJJLCbexLYRBIZzAIJBhI7a1tuWaUJfCWVSridLwE4/WZ+ARyRiDNy1oYyEUgGsVXfCwwCGRFWM1LVhgEolF9weeFnMeCnd9y8CHw+UL/pdPXWQzsN7O8cOyPbPgOqgYDkLbaZ3FI2mC/maWkadsssXOiGgzA0cBAaXjq+PC2NX0CmUCkLYoZzZ5JwbXvpt6MNhDUm0Ck7WhjmArG6ECmgzEykClhjApkVxjp3t5q2/sasiuM2hUcDaZnIPhwt/u7qWgAZfxegSzBeNu64FKw6OPW47skXzcwUGwJ4JIBzNSnKxhHB9IdjCMD6RLGUYHgC8Hau6nmCzgAlHa0NWQJxrtSmL2OjwSkexi4CI4CZAgYRwECGOWTPhx3c5sCiGSzz5AajD8y+C5hAMrMQJZgvE9XY4/bWYEMCWPWGVL7QQJuU13PjDRbZ5shVzIwiJ+PaxgYgJIXjv2R7UqKHxoGxJ8FyIcZYMwCZBoYMwCZCsboQGow8C+TPmJgo9qoawj+xLi2gAPS0DYikJMo/kNaXjvgDA8DV1I+KOyPYADyXVqqfRoYED8NKm1xbgR7JEUCyjdp+GQ+heFKK2cFztF2UqDpH4rsNMah0v4Hs5z1AMNfJJUAAAAASUVORK5CYII="
          />
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default SpecializationIcon;
